import React from "react";

/* e-Invoice / e-way bill status (GENERATED / NOT_GENERATED / CANCELLED / REJECTED …) */
const EInvoiceStatusBadge = ({ status }) => {
  if (!status) return <span className="text-[var(--placeholder-color)]">--</span>;
  const color =
    status === "GENERATED"
      ? "var(--success-color)"
      : status === "CANCELLED" || status === "REJECTED"
        ? "var(--error-color)"
        : "var(--draft-color)";
  const label = String(status)
    .toLowerCase()
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
  return (
    <div
      className="border text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit"
      style={{ borderColor: color, color }}
    >
      {label}
    </div>
  );
};

export default EInvoiceStatusBadge;
